export default {"src":"/_next/static/media/gradient_storefront.da1c6707.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};